import * as moment from 'moment';
import { TimeInterval, IPeriodConfiguration, PeriodReference } from '../../models';

export class WidgetIntervalHelper {
    getInterval(beginDate: string, endDate: string, configuration: IPeriodConfiguration, defaultDuration: moment.Duration): { beginMoment: moment.Moment, endMoment: moment.Moment } {
        let beginMoment = moment(beginDate);
        let endMoment = moment(endDate);

        // Compute current interval length
        const intervalDuration = moment.duration(endMoment.diff(beginMoment));
        const actualDuration = this.getActualDuration(configuration, intervalDuration);

        switch (configuration.alignedOn) {
            case PeriodReference.Begin:
                endMoment = beginMoment.clone().add(actualDuration);
                break;
            case PeriodReference.Middle:
                const halfInterval = moment.duration(intervalDuration.asMilliseconds() / 2, 'ms');
                const halfDuration = moment.duration(actualDuration.asMilliseconds() / 2, 'ms');
                beginMoment = beginMoment.add(halfInterval)
                    .subtract(halfDuration);
                endMoment = beginMoment.clone().add(actualDuration);
                break;
            case PeriodReference.End:
            default:
                beginMoment = endMoment.clone().subtract(actualDuration);
                break;
        }
        if (configuration.isEndDateIncluded) {
            endMoment.add(defaultDuration);
        }
        return { beginMoment, endMoment };
    }

    private getActualDuration(configuration: IPeriodConfiguration, actualDuration: moment.Duration) {
        if (configuration.minPeriod && configuration.minPeriod.interval > 0) {
            const minDuration = this.getDuration(configuration.minPeriod);
            actualDuration = minDuration < actualDuration
                ? actualDuration
                : minDuration;

        }
        if (configuration.maxPeriod && configuration.maxPeriod.interval > 0) {
            const maxDuration = this.getDuration(configuration.maxPeriod);
            actualDuration = maxDuration > actualDuration
                ? actualDuration
                : maxDuration;
        }
        return actualDuration;
    }

    private getDuration(value: TimeInterval): moment.Duration {
        const minPeriod = new TimeInterval();
        minPeriod.interval = value.interval;
        minPeriod.unit = value.unit;
        const minDuration = minPeriod.duration();
        return minDuration;
    }
}